import * as React from "react";
import { Form } from "semantic-ui-react";

export type ColumnSelectionProps = {
  columns: State.Column[];
  handleColumnSelection: (name: string, value: boolean) => void;
};

const ColumnSelection: React.FC<ColumnSelectionProps> = ({
  columns,
  handleColumnSelection
}): JSX.Element => (
  <Form>
    <Form.Group grouped={true}>
      {columns.map(column =>
        (column as any).expander ? null : (
          <Form.Checkbox
            key={column.name}
            label={column.name}
            checked={column.isVisible}
            onChange={() => handleColumnSelection(column.name, !column.isVisible)}
          />
        )
      )}
    </Form.Group>
  </Form>
);

export default ColumnSelection;
